import useLazyBaseFetch from "../../internal/fetch/useLazyBaseFetch";
/**
 * @see https://sail.stripe.me/data/api/useLazyTextFetch
 */ export default function useLazyTextFetch(/** The URL of the resource to be fetched. */ url, /** An object containing custom settings to be applied to the request. */ options = {}) {
    return useLazyBaseFetch(url, options, 'text');
}

//# sourceMappingURL=useLazyTextFetch.js.map